<script>
import api from '@/api'
import { alertSuccess, alertConfirm } from '@/helpers/swal'
import pagination from '@/components/pagination.vue'

export default {
  data() {
    return {
      loading: true,
      pagetitle: 'Users',
      users: [],
      totalItems: 0,
      totalPages: 1,
      currentPage: 0,
      perPage: 10,
      baseUrl: `${window.apiUrl}/admin/accounts/list`,
    }
  },
  components: {
    pagination,
  },
  async mounted() {
    await this.getUsers()
  },
  methods: {
    async getUsers() {
      const params = {
        page: this.currentPage,
        size: this.perPage,
      }
      await api
        .get(this.baseUrl, { params })
        .then((response) => {
          this.users = response.data?.users || []
          this.totalItems = response.data.totalItems
          this.totalPages = response.data.totalPages
          this.currentPage = response.data.currentPage
        })
        .finally(() => {
          this.loading = false
        })
    },

    deleteUser(userId) {
      alertConfirm('You want to delete this user').then((result) => {
        if (result.value) {
          api.post(`/admin/accounts/remove/${userId}.json`).then(() => {
            alertSuccess('User deleted successfully')
            this.getUsers()
          })
        }
      })
    },

    updatePage(newPage) {
      this.loading = true
      this.currentPage = newPage - 1
      this.getUsers()
    },

    showActionColumn() {
      return this.authUserHasPermission('system_admin_accounts_edit') || this.authUserHasPermission('system_admin_accounts_delete')
    },
  },
}
</script>

<template>
  <Teleport to="#elePageTitle">
    {{ pagetitle }}
  </Teleport>
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <div class="row g-3 align-items-center">
            <div class="col-lg-4 col-md-6">
              <!-- <div class="input-group">
                <input type="search" class="form-control" placeholder="Search here" />
                <span class="input-group-text cursor-pointer">
                  <i class="bx bx-search"></i>
                </span>
              </div> -->
            </div>
            <div class="col-md-6 col-lg">
              <div class="d-flex justify-content-end">
                <router-link to="/users/create" class="btn btn-primary d-flex align-items-center gap-1" v-if="authUserHasPermission('system_admin_accounts_add')">
                  <i class="bx bx-plus"></i>
                  Add New
                </router-link>
              </div>
            </div>
          </div>
          <!-- end row -->
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-lg-12">
              <div class="table-responsive">
                <table class="table mb-0">
                  <thead class="table-light">
                    <tr>
                      <th>Username</th>
                      <th>Name</th>
                      <th>Role</th>
                      <th>Email</th>
                      <th v-if="showActionColumn()">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-if="loading">
                      <tr v-for="n in 5" :key="n">
                        <td v-for="m in showActionColumn() ? 5 : 4" :key="m" class="placeholder-glow">
                          <span class="placeholder col-12"></span>
                        </td>
                      </tr>
                    </template>
                    <template v-else-if="users.length">
                      <tr v-for="(user, userIndex) in users" :key="userIndex">
                        <td>{{ user.username }}</td>
                        <td>{{ user.fullName }}</td>
                        <td>
                          <span class="badge badge-soft-primary">{{ user.roleName }}</span>
                        </td>
                        <td>{{ user.email }}</td>
                        <td v-if="showActionColumn()">
                          <div class="d-flex gap-2">
                            <router-link
                              :to="'/users/' + user.userId + '/edit'"
                              class="btn btn-primary bg-gradient btn-sm"
                              data-bs-toggle="tooltip"
                              data-bs-placement="top"
                              title="Edit"
                              v-if="authUserHasPermission('system_admin_accounts_edit')"
                            >
                              <eva-icon name="edit" data-eva-height="14" data-eva-width="14" class="fill-white align-text-top"></eva-icon>
                            </router-link>
                            <button
                              type="button"
                              class="btn btn-danger bg-gradient btn-sm"
                              data-bs-toggle="tooltip"
                              data-bs-placement="top"
                              title="Delete"
                              @click="deleteUser(user.userId)"
                              v-if="authUserHasPermission('system_admin_accounts_delete')"
                            >
                              <eva-icon name="trash-2" data-eva-height="14" data-eva-width="14" class="fill-white align-text-top"></eva-icon>
                            </button>
                          </div>
                        </td>
                      </tr>
                    </template>
                    <template v-else>
                      <tr>
                        <td colspan="5" class="text-center">No users found</td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <!-- end row -->
        </div>
        <div v-if="!loading && users.length" class="card-footer">
          <pagination :baseUrl="baseUrl" :totalItems="totalItems" :perPage="perPage" :currentPage="currentPage + 1" @page-changed="updatePage" />
        </div>
      </div>
    </div>
  </div>
</template>
